import React, { FC } from 'react';
import s from './toyCartItem.module.scss';
import cn from 'classnames';
import { Checkbox } from '@components/UIKit/Checkbox/Checkbox';
import { Button } from '@components/UIKit/Button/Button';
import { useTranslation } from '@hooks/useTranslation';
import Skeleton from 'react-loading-skeleton';
import { SpriteIcon } from '@components/Sprites/SpriteIcon';
import { Currency } from '@components/UIKit/Currency/Currency';
import { Counter } from '@components/Cards/Counter/Counter';
import { ICartItemToys } from '@services/store/helpers/cart';
interface CartItemLoaderProps {
  toyId: ICartItemToys['toyId'];
  figures: ICartItemToys['figures'];
}
export const ToysCartItemLoader: FC<CartItemLoaderProps> = ({
  toyId,
  figures
}) => {
  const {
    translate: tr
  } = useTranslation();
  return <div className={s.toyCartItem} data-sentry-component="ToysCartItemLoader" data-sentry-source-file="ToysCartItemLoader.tsx">
            <div className={s.toyCartItem__box}>
                <div className={s.toyCartItem__left}>
                    <Checkbox checked={false} name={`cart_toy_id_${toyId}`} data-sentry-element="Checkbox" data-sentry-source-file="ToysCartItemLoader.tsx" />
                    <div className={s.toyCartItem__toy}>
                        <Skeleton containerClassName={s.toyCartItem__toy} width={'100%'} data-sentry-element="Skeleton" data-sentry-source-file="ToysCartItemLoader.tsx" />
                        <div className={s.toyCartItem__body}>
                            <div className={s.toyCartItem__header}>
                                <div className={s.toyCartItem__info}>
                                    <div className={cn(s.toyCartItem__name, '_ellipsis')}>
                                        {tr({
                    id: 'btn.loading'
                  })}
                                    </div>
                                </div>

                                <Button id='default_button' className={cn(s.toyCartItem__squareBtn, '_mobile')} size={'small'} color={'Light-Red'} disabled data-sentry-element="Button" data-sentry-source-file="ToysCartItemLoader.tsx">
                                    <SpriteIcon name={'trash'} data-sentry-element="SpriteIcon" data-sentry-source-file="ToysCartItemLoader.tsx" />
                                </Button>
                            </div>
                            <Counter className={s._hideBeforeContainerMedia} count={figures.length} countHandler={() => {}} disabled data-sentry-element="Counter" data-sentry-source-file="ToysCartItemLoader.tsx" />
                            {figures.length === 1 && <Button id='toy_cart_buy_only_toy' size={'small'} color={'Zhen Zhu Bai Pearl'} disabled icons={{
              left: {
                name: 'light'
              }
            }}>
                                    {tr({
                id: 'cart.page.buy.this.toy.only'
              })}
                                </Button>}
                        </div>
                    </div>
                </div>

                <Counter className={s._hideAfterContainerMedia} count={figures.length} countHandler={() => {}} disabled data-sentry-element="Counter" data-sentry-source-file="ToysCartItemLoader.tsx" />
                <div className={s.toyCartItem__right}>
                    <Button id='default_button' className={cn(s.toyCartItem__squareBtn, '_desktop')} size={'small'} color={'Light-Red'} disabled data-sentry-element="Button" data-sentry-source-file="ToysCartItemLoader.tsx">
                        <SpriteIcon name={'trash'} data-sentry-element="SpriteIcon" data-sentry-source-file="ToysCartItemLoader.tsx" />
                    </Button>
                    <div className={s.toyCartItem__list}>
                        {figures.map(({
            price,
            instanceId,
            currency,
            storeItemId
          }) => <div key={storeItemId} className={s.selectedItem}>
                                <div className={cn(s.selectedItem__instanceId, '_instanceId', '_ellipsis')}>
                                    #{instanceId}
                                </div>
                                <div className={s.selectedItem__currency}>
                                    <Currency amount={price} currency={currency} />
                                </div>
                                <Button id='default_button' className={s.selectedItem__edit} size={'small'} color={'Transparent'} disabled>
                                    {tr({
                id: 'edit'
              })}
                                </Button>
                            </div>)}
                    </div>
                </div>
            </div>
        </div>;
};